import React, { useState, useEffect } from 'react';
import DataCollection from '../../shared/DataCollection';
import BreedCardList from './BreedCardList.js';
import { useTranslation } from 'react-i18next';

export const ListBreeds = (props) => {
  const systemAccount = "000000000000000000000000";
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const collection = 'breeds';

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  const columns = [
    {name: t("breed"),      selector: row => row.name, cell: row => <span className="breed-text">{row.name}</span>},
    {name: t("nicknames"),  selector: row => row.matches},
    {
      name: t("breed_type"),
      selector: row => row.account === systemAccount ?
        t("breed_type_system") : t("breed_type_custom"),
      sortable: true,
    },
    {name: t("created_by"), selector: row => row.created_by},
  ];

  return (
    <DataCollection
      collection={collection}
      columns={columns}
      sortField={3}
      mobileComponent={(data, onRefresh) => (
        <BreedCardList data={data} onRefresh={onRefresh} />
      )}
    />
  );
}

export default ListBreeds;
